import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';

const blackmilkclothingSizeOptions = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
  'XS/S',
  'M/L',
  'XL/XXL',
  'XXXL/XXXXL',
  '6',
  '8',
  '10',
  '12',
  '14',
  '16',
  '18',
  '20',
  'ONESIZE',
];

const blackmilkclothingUSAdditionalPayoutSettings = {
  additionalShopifyGiftCardRequirements: {
    giftCardExpiresAfterDays: 365, // 1 year
  },
  creditCodeHelperText: 'Gift card expires 1 year after date of issue.',
};

export const blackmilkclothingUsShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getSizeFilterConfig({ sizes: blackmilkclothingSizeOptions }),
  ],
  additionalPayoutSettings: blackmilkclothingUSAdditionalPayoutSettings,
  builderConfig: {
    sections: {
      [BuilderSections.LandingPageContent]: 'e690c837406c43ba999a7fe5f15d66d1',
      [BuilderSections.TopbarContent]: 'd75e2089c3ec4caeaa0de2c0f0ece278',
      [BuilderSections.TopbarMobileContent]: '62c72ca98b5f432c88a692b90b8e0dba',
      [BuilderSections.AboutPageInfoTabContent]: 'aa3f3c2880004e709102ce13bc3494a8',
    },
  },
};
